import api from '@/api/api'
import {
    Notification
} from 'element-ui'


const state = {
  	customerTypes: []
}

const getters = {
  	getCustomerTypes: state => state.customerTypes
}

const mutations = {
	ADD_CUSTOMER_TYPE (state, customerType) {
		state.customerTypes.push(customerType)
	},
	EMPTY_CUSTOMER_TYPES (state) {
		state.customerTypes = []
	},
	REMOVE_CUSTOMER_TYPE (state, id) {
		for (let item of state.customerTypes) {
            if (item.id === id) {
                let index = state.customerTypes.indexOf(item)
                state.customerTypes.splice(index, 1)
            }
        }
	}
}

const actions = {
  	async fetchCustomerTypes ({ commit }) {
		let dist = await api.fetchCustomerTypes()
		dist = dist.data.data
		commit('EMPTY_CUSTOMER_TYPES')
		dist.forEach(function (elem) { commit('ADD_CUSTOMER_TYPE', elem) })
	},
	async saveCustomerType ({commit}, req) {
		let response
		await api.saveCustomerType(req)
		.then((res) => {
			if (res) {
				if (res.status === 201) {
					Notification.success({
						title: 'Success',
						message: 'Customer type has been successfully created.'
					})
					response = 'success'
				}
			}
		})
		.catch((err) => {
			if (err) {
				if (err.status === 422) {
					console.log(err.data);
					
					response = err.data
				}
			} else {
				Notification.error({
					title: 'Error',
					message: 'An error saving customer type has occured.'
				})
			}
		})
		return response

	},
	async updateCustomerType ({commit}, req) {
		let response
		await api.updateCustomerType(req.id, req)
		.then((res) => {
			console.log(res);
			
			if (res) {
				if (res.status === 200) {
					Notification.success({
						title: 'Success',
						message: 'Customer type has been successfully updated.'
					})
					response = 'success'
				}
			}
		})
		.catch((err) => {
			if (err) {
				if (err.status === 422) {
					console.log(err.data);
					response = err.data
				}
			} else {
				Notification.error({
					title: 'Error',
					message: 'An error saving customer type has occured.'
				})
			}
		})
		return response

	},
	async deleteCustomerType ({commit}, id) {
		await api.deleteCustomerType(id)
		.then((res) => {
			if (res.status) {
				if (res.status === 204) {
					commit('REMOVE_CUSTOMER_TYPE', id)
					Notification.success({
						title: 'Success',
						message: 'Customer type has been successfully removed.'
					})
					return 'success'
				} else {
					return 'error'
				}
			} else {
				Notification
				return 'error'
			}
		})
	},
}

export default {
	state,
	getters,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/customerTypes.js